import React, { useState, useEffect, useCallback } from 'react';
import { Tooltip, makeStyles } from '@material-ui/core';
const useStylesBootstrap = makeStyles(theme => ({
  tooltip: {
    background: 'linear-gradient(to top, hsl(200 50% 50%), hsl(180 50% 50%))',
    color: 'white',
    fontSize: theme.spacing(1.7),
    padding: theme.spacing(1.5)
  }
}));

export function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow={true} classes={classes} {...props} />;
}
